import { BaseEntity } from "@bndes/bndes-ux4/bndes-angular-utils";
import { BaseModel } from './base-model.model';

export class RespostaVersao extends BaseEntity {

    versao: string;

    constructor(id?: number, versao?: string) {
        super();
        this.id = id;
        this.versao = versao;
    }
}
